import { ReadOnlyModel, useModelKey, useValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import React from 'react'
import { HighlightCard } from 'ui/cards'
import { ProgressBar } from 'ui/elements'
import { observer } from 'mobx-react'

function ScheduleCostDistributionHighlightCard () {
  const activeCategory = useValue('category')
  const costDistributionKitchen = useValue('cost_distribution_kitchen')
  const costDistributionWaiter = useValue('cost_distribution_waiter')

  const ratioDistribution = activeCategory === 'kitchen' ? costDistributionKitchen : costDistributionWaiter

  const distributionTitle = (activeCategory === 'kitchen') ? (
    <>
      <Translation name='generic.kitchen' />
      <span>: </span>
      <Displays.Percentage name='cost_distribution_kitchen' decimals={0} />
      <span> - </span>
      <Translation name='generic.waiter' />
      <span>: </span>
      <Displays.Percentage name='cost_distribution_waiter' decimals={0} />
    </>
  ) : (
    <>
      <Translation name='generic.waiter' />
      <span>: </span>
      <Displays.Percentage name='cost_distribution_waiter' decimals={0} />
      <span> - </span>
      <Translation name='generic.kitchen' />
      <span>: </span>
      <Displays.Percentage name='cost_distribution_kitchen' decimals={0} />
    </>
  )

  return (
    <HighlightCard
      box='Live' title={distributionTitle}
      content={<ProgressBar
        progress={[{ color: 'bg-primary-500', progress: ratioDistribution * 100 }]}
        classNames={['mt-2']}
               />}
    />
  )
}

export default observer(ScheduleCostDistributionHighlightCard)
